import { useState, useEffect, useRef } from 'react';

// Hook personalizado para detectar si un elemento está en el viewport
export const useInView = (threshold = 0.1) => {
  // Estado para saber si el elemento está en vista actualmente
  const [isInView, setIsInView] = useState(false);
  // Estado para saber si el elemento ha entrado alguna vez en vista
  const [hasEntered, setHasEntered] = useState(false);
  // Referencia al elemento DOM que se va a observar
  const elementRef = useRef(null);
  
  useEffect(() => {
    // Crea el observer con el threshold especificado
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Actualiza si el elemento está en vista
        setIsInView(entry.isIntersecting);
        // Marca que el elemento ha entrado en vista al menos una vez
        if (entry.isIntersecting && !hasEntered) {
          setHasEntered(true);
        }
      },
      { threshold }
    );
    
    // Observa el elemento referenciado si existe
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
    
    // Limpia el observer al desmontar o cambiar dependencias
    return () => observer.disconnect();
  }, [threshold, hasEntered]);
  
  // Retorna la referencia y los estados para usar en el componente
  return { elementRef, isInView, hasEntered };
};